/*
  Radio Filter Selector
  Enhance a radio group to look like a range selector (without the dragging part)
*/

/*
  Radio Filter Selector core
  @param group - Grand-Parent element class (.custom-radio-group)
  @param block - Parent element class (.custom-radio)
*/
const radioFilterSelector = (group, block) => {
  const radioGroupClass = group || ".custom-radio-group";
  const radioBlockClass = block || ".custom-radio";
  const radioLabelClass = `${radioBlockClass}__label`;
  const radioInputClass = `${radioBlockClass}__control`;
  const toggleClass = `${radioLabelClass.replace(/^\./, "")}--fakecheck`;

  // Search for existing radio groups
  const radioGroupList = document.querySelectorAll(radioGroupClass);
  if (radioGroupList) {
    [].slice.call(radioGroupList).forEach((radioGroup) => {
      // Add class on load to the checked one
      let radioChecked = radioGroup.querySelector(`${radioInputClass}:checked`);
      const labelChecked = radioGroup.querySelector(
        `.custom-radio__label[for="${radioChecked.getAttribute("id")}"]`
      );
      labelChecked.classList.add(toggleClass);

      // Search for existing input radio
      const radioInput = radioGroup.querySelectorAll(radioInputClass);
      if (radioInput) {
        [].slice.call(radioInput).forEach((input) => {
          input.addEventListener("click", (el) => {
            const inputRadio = el.target;
            const clicked = parseInt(inputRadio.dataset.nb, 10);
            const checked = parseInt(radioChecked.dataset.nb, 10);

            if (clicked < checked) {
              // Reverse loop through element from the checked to the clicked one
              // Add class sequencially
              for (let i = checked; i > clicked; i -= 1) {
                setTimeout(
                  () => {
                    const inputLoop = radioGroup
                      .querySelector(`[data-nb="${i}"]`)
                      .getAttribute("id");
                    const label = radioGroup.querySelector(
                      `.custom-radio__label[for="${inputLoop}"]`
                    );
                    label.classList.remove(toggleClass);
                  },
                  100 * (checked + 1 - i),
                  i
                );
              }
            }

            if (clicked > checked) {
              // Loop through element from the checked to the clicked one
              // Add class sequencially
              for (let i = checked; i <= clicked; i += 1) {
                setTimeout(
                  () => {
                    const inputLoop = radioGroup
                      .querySelector(`[data-nb="${i}"]`)
                      .getAttribute("id");
                    const label = radioGroup.querySelector(
                      `.custom-radio__label[for="${inputLoop}"]`
                    );
                    label.classList.add(toggleClass);
                  },
                  100 * i - 200,
                  i
                );
              }
            }

            // Update checked element
            radioChecked = radioGroup.querySelector(
              `${radioInputClass}:checked`
            );
          });
        });
      }
    });
  }
};

export default radioFilterSelector;
